module.exports = __webpack_public_path__ + "img/seaweed.91931904.png";